exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tw-1 {\n    fill: #03a9f4;\n  }\n", ""]);
